import React from 'react';
import PropTypes from 'prop-types';

import { HeaderType } from '../../constants/filters';

import {
  StyledHeader,
  BaseHeader,
  ControlledHeader,
  SearchBar,
  ArrowUp,
  CheckBox
} from './Styles';

const propTypes = {
  closePopOver: PropTypes.func.isRequired,
  setList: PropTypes.func.isRequired,
  setIsDirty: PropTypes.func.isRequired,
  setDirtyList: PropTypes.func.isRequired,
  headerType: PropTypes.string,
  list: PropTypes.objectOf(PropTypes.object).isRequired,
  searchEnabled: PropTypes.bool.isRequired,
  searchPlaceHolder: PropTypes.string,
  allSelectedText: PropTypes.string,
  numItems: PropTypes.number.isRequired,
  numItemsSelected: PropTypes.number.isRequired,
  setNumItemsSelected: PropTypes.func.isRequired,
  hasChild: PropTypes.bool.isRequired,
  testId: PropTypes.string
};

const defaultProps = {
  headerType: '',
  searchPlaceHolder: '',
  allSelectedText: '',
  testId: undefined
};

const Header = ({
  closePopOver,
  setList,
  setIsDirty,
  headerType,
  headerTitle,
  list,
  setDirtyList,
  searchEnabled,
  searchPlaceHolder,
  allSelectedText,
  numItems,
  numItemsSelected,
  setNumItemsSelected,
  hasChild,
  testId
}) => {
  /**
   * Filter list based on search term (child)
   */
  const filterItemsChild = event => {
    event.stopPropagation();
    const searchValue = event?.target?.value;
    if (searchValue) {
      setDirtyList(() => {
        const updatedState = {};
        Object.keys(list).forEach(id => {
          updatedState[id] = {
            ...list[id],
            children: list[id].children.filter(child => {
              return child.displayName
                .toLowerCase()
                .startsWith(searchValue.toLowerCase());
            })
          };
        });

        return updatedState;
      });
      setIsDirty(true);
    } else {
      setIsDirty(false);
    }
  };

  /**
   * Filter list based on search term
   */
  const filterItems = event => {
    const searchValue = event?.target?.value;
    if (searchValue) {
      setDirtyList(() => {
        const updatedState = {};

        Object.keys(list).forEach(id => {
          const match = list[id].displayName
            .toLowerCase()
            .startsWith(searchValue.toLowerCase());

          if (match) {
            updatedState[id] = { ...list[id] };
          }
        });

        return updatedState;
      });
      setIsDirty(true);
    } else {
      setIsDirty(false);
    }
  };

  const selectAllChild = e => {
    const isChecked = e?.target?.checked;

    setList(prevState => {
      const modifiedState = {};
      Object.keys(prevState).forEach(id => {
        modifiedState[id] = {
          ...prevState[id],
          children: prevState[id].children.map(child => {
            return {
              ...child,
              isSelected: isChecked
            };
          }),
          isSelected: isChecked
        };
      });

      return modifiedState;
    });

    setNumItemsSelected(() => (isChecked ? numItems : 0));
  };

  const selectAll = e => {
    const isChecked = e?.target?.checked;

    setList(state => {
      Object.keys(state).forEach(id => {
        const copy = state[id];
        copy.isSelected = isChecked;
      });
      return state;
    });

    setNumItemsSelected(() => (isChecked ? numItems : 0));
  };

  return (
    <StyledHeader>
      {headerType === HeaderType.Base && (
        <BaseHeader>
          <div>{headerTitle}</div>
          <ArrowUp clickHandler={closePopOver} />
        </BaseHeader>
      )}

      {headerType === HeaderType.Controlled && (
        <ControlledHeader>
          {searchEnabled && (
            <SearchBar
              placeholder={searchPlaceHolder}
              onChange={e => (hasChild ? filterItemsChild(e) : filterItems(e))}
              data-testid={testId}
            />
          )}
          <div>
            <CheckBox
              onChange={e => (hasChild ? selectAllChild(e) : selectAll(e))}
              checked={numItems === numItemsSelected}
              data-testid={`${testId.replace('-search-bar', '')}-all-selected`}
            />
            <span>{allSelectedText}</span>
          </div>
        </ControlledHeader>
      )}
    </StyledHeader>
  );
};

Header.propTypes = propTypes;
Header.defaultProps = defaultProps;

export default Header;
